import inputKeys from '../constants/InputKeys';

export default {
  getJobID() {
    return this.__getValueFromUrl(inputKeys.JOB_ID, undefined);
  },
  getJobCityWorkLocationID() {
    return this.__getValueFromUrl(inputKeys.JOB_CITY_WORK_LOCATION_ID, undefined);
  },
  getMitraID() {
    return this.__getValueFromUrl(inputKeys.MITRA_ID, undefined);
  },
  getUTMSource() {
    return this.__getValueFromUrl(inputKeys.UTM_SOURCE, undefined);
  },
  getShowNewLandingPage() {
    return this.__getValueFromUrl(inputKeys.SHOW_NEW_LANDING_PAGE, undefined);
  },
  getOnBoardingFlag() {
    return this.__getValueFromUrl(inputKeys.OB2, 'false');
  },
  getFADFlag() {
    return this.__getValueFromUrl(inputKeys.FAD, 'false');
  },
  getLLPFlag() {
    const val = this.__getValueFromUrl(inputKeys.LLP, 'en');
    if (['en', 'kn', 'hi'].includes(val)) {
      return val;
    }
    return 'en';
  },
  __getValueFromUrl(key, defaultValue) {
    return (
      this.convertToObject(decodeURIComponent(window.location.href).replace(/&amp;/g, '&'))[key] ||
      defaultValue
    );
  },
  convertToObject(url) {
    const paramsString = url.substring(url.indexOf('?') + 1, url.length);

    const arr = paramsString.slice(0).split(/&|=/); // remove the "?", "&" and "="
    const params = {};

    for (let i = 0; i < arr.length; i += 2) {
      const key = arr[i];
      const value = arr[i + 1];
      params[key] = value; // build the object = { limit: "10", page:"1", status:"APPROVED" }
    }

    return params;
  },
  getJsonFromUrl(url) {
    // eslint-disable-next-line no-param-reassign
    if (!url) url = window.location.href;
    const question = url.indexOf('?');
    let hash = url.indexOf('#');
    if (hash === -1 && question === -1) return {};
    if (hash === -1) hash = url.length;
    const query =
      question === -1 || hash === question + 1
        ? url.substring(hash)
        : url.substring(question + 1, hash);
    const result = {};
    query.split('&').forEach(function(part) {
      if (!part) return;
      // eslint-disable-next-line no-param-reassign
      part = part.split('+').join(' '); // replace every + with space, regexp-free version
      const eq = part.indexOf('=');
      let key = eq > -1 ? part.substr(0, eq) : part;
      const val = eq > -1 ? decodeURIComponent(part.substr(eq + 1)) : '';
      const from = key.indexOf('[');
      if (from === -1) result[decodeURIComponent(key)] = val;
      else {
        const to = key.indexOf(']', from);
        const index = decodeURIComponent(key.substring(from + 1, to));
        key = decodeURIComponent(key.substring(0, from));
        if (!result[key]) result[key] = [];
        if (!index) result[key].push(val);
        else result[key][index] = val;
      }
    });
    return result;
  },
};
